import axiosInstance from "../../../../axiosInstance";
import { success, error, info } from "../../../../store/notification/actions";
import history from "../../../../history";
import {
  addLocalStorageData,
  addSessionData,
  getLocalStorageData,
  getSessionData,
  removeSessionData,
} from "../../base/helper/baseHelper";

import * as CryptoJS from "crypto-js";

import { AIMS_SECRET_KEY, AIMS_INITIAL_VECTOR } from "../../../constants/baseConstants";

function aesEncrypt(data) {
  let cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(AIMS_SECRET_KEY), {
      iv: CryptoJS.enc.Utf8.parse(AIMS_INITIAL_VECTOR),
      mode: CryptoJS.mode.CBC,
  });
  return cipher.toString();
}

export async function signIn(data) {
  if (data != null) {
    info("Signing in ...");
    return await axiosInstance
      .post("/user/signIn", {
        userid: data.username,
        password: aesEncrypt(data.password),
      })
      .then((response) => {
        info("Signing in ...");
        if (!isLoggedIn(response.data.data.userid)) {
          success("Signed in successfully!");
          
        authenticate(response.data.data ? response.data.data : "");
          history.push("/apps");
          return response.data.data;
        } else {
          error("You have logged in already!")
          return { message: "You have logged in already", hasError: true, data: "" };
        }

      })
      .catch((err) => {
        error(err.response.data.error[0].message);
        return {
          message: err.response.data.error[0].message,
          hasError: true,
          data: "",
        };
      });

  } else {
    error("Internal error occurred");
    return { message: "Internal error occurred", hasError: true, data: "" };
  }
}

export const signOut = (next) => {
  if (typeof window !== "undefined") {
    removeSessionData({ key: "authToken" });
    removeSessionData({ key: "store" });
    const userId = getSessionData({ key: "userId" })
    removeSessionData({ key: "userId" });
    removeSessionData({ key: "userData" });
    const loggedUsers = JSON.parse(getLocalStorageData({ key: 'loggedUsers' })) || []
    addLocalStorageData({ key: "loggedUsers", value: JSON.stringify(loggedUsers.filter(user => user !== userId)) })
    removeSessionData({ key: "isglobalUser" });
    return;
  }
};

export const authenticate = (data, next) => {
  if (
    typeof window !== "undefined" &&
    data &&
    data.authToken &&
    data.authToken !== ""
  ) {
    const loggedUsers = JSON.parse(getLocalStorageData({ key: "loggedUsers" })) || []
    addSessionData({ key: "authToken", value: data.authToken });
    addSessionData({ key: "userId", value: data.userid });
    const userData = {
      userid : data.userid,
      rolename : data.rolename,
      lastlogin : data.lastlogintimestamp
    }
    addSessionData({ key: "userData", value: JSON.stringify(userData) });
    
    loggedUsers.push(data.userid)
    addLocalStorageData({ key: "loggedUsers", value: JSON.stringify(loggedUsers) })
    addSessionData({ key: "isglobalUser", value: data.isglobal });
    addSessionData({key: "isAdmin", value: data.isadmin});
  }
};

export const isAuthenticated = () => {
  if (typeof window == "undefined") {
    return false;
  }
  const authToken = getSessionData({ key: "authToken" });

  if (authToken) {
    return authToken;
  } else {
    return false;
  }
};

export const isLoggedIn = (userId) => {
  return false;
}